// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"bd4d4fe2","373":"d6596ffd","944":"31d6cfe0"}[chunkId] + ".chunk.css";
};